import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CodeComponent } from './code/code.component';
import * as hljs from 'highlight.js';
import { HighlightJsModule, HIGHLIGHT_JS } from 'angular-highlight-js';

export function highlightJsFactory() {
  return hljs;
}

@NgModule({
  imports: [
    CommonModule,
    HighlightJsModule.forRoot({
      provide: HIGHLIGHT_JS,
      useFactory: highlightJsFactory
    })
  ],
  exports:[CodeComponent],
  declarations: [CodeComponent]
})
export class CodeModule { }



// WEBPACK FOOTER //
// ./src/app/component/code/code.module.ts